import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../utils/Utils";
import PazientiService from "../../../../../services/PazientiService";
import Button from "../../../../../components/button/Button";
import stylesWelcome from "../DatiSegnalazioneAnagrafici.module.css";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import styles from "../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Input from "../../../../../components/textbox/Input";
import Calendar from "../../../../../components/calendar/Calendar";
import Autocomplete from "../../../../../components/autocomplete/Autocomplete";
import Table from "../../../../../components/table/Table";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import OggettiUtili from "../../../../../utils/OggettiUtili.json";
import $ from "jquery";
import CheckBox from "../../../../../components/checkbox/CheckBox";
import ToasterSingleton from "../../../../../singleton/ToasterSingleton";
import toasterConfig from "../../../../../config/toasterConfig";
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import Ruoli from "../../../../../utils/Ruoli";
import moment from "moment";

class DatiAnagraficiPaziente extends Component {

    state = {
        datiPaziente: {
            idAnagrafica: "",
            nomePaziente: "",
            cognomePaziente: "",
            dataDiNascita: "",
            codiceFiscale: "",
            stp: "",
            sesso: "",
            eta: "",
            mesi: "",
            comuneNascita: "",
            cfNonNoto: "",
            nonInRegola: "",
            senzaFissaDimora: "",
            regioneResidenza: "",
            provinciaResidenza: "",
            comuneResidenza: "",
            indirizzoResidenza: "",
            aslAppartenenza: "",
            comuneDomicilio: "",
            indirizzoDomicilio: "",
            aslDomicilio: "",
            cittadinanza: "",
            recapitoTelefonicoPaziente: "",
            ssn: "",
            professione: "",
            soggettoAnonimizzato: "",
        },
        disabledPulisciCampi: true,
        disabledCercaPaziente: true,
        disableSoggetto: false,
        formPazienteSpecifico: this.props.formPazienteSpecifico ,
        rowsTabPaziente: [],
        totalElementsTabPaziente: 0,
        showTablePaziente: false,
        regioni: OggettiUtili.Regioni,
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        province: JSON.parse(sessionStorage.getItem("province")),
        provincePerCodice:JSON.parse(sessionStorage.getItem("provincePerCodice")),
        comuni: Utils.distinctComuni(JSON.parse(sessionStorage.getItem("comuni"))),
        comuniNascita: Utils.distinctComuni(JSON.parse(localStorage.getItem("comuni"))),
        comuniAulssPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        disabled: false,
        malattieConSchedaSpeciale: OggettiUtili.malattieConSchedaSpeciale,
        disabledDataNascitaRicerca: false,
        updateCalendar: false,
        aulssByCodiceComuneResidenza: "",
        aulssByCodiceComuneDomicilio: "",
        aulss: JSON.parse(localStorage.getItem("aulss")),


    }

    constructor(props) {
        super(props);

        this.props.setDatiPaziente(this.state.datiPaziente)
        this.selezionaPaziente = this.selezionaPaziente.bind(this)
        this.pulisciCampiPaziente = this.pulisciCampiPaziente.bind(this)
        this.sendRequestPaziente = this.sendRequestPaziente.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.disabilitaCercaPaziente = this.disabilitaCercaPaziente.bind(this)
        this.letturaPaziente = this.letturaPaziente.bind(this)
        this.disableDataDiNascitaERadioButton = this.disableDataDiNascitaERadioButton.bind(this)
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.disablePicker = this.disablePicker.bind(this);
    }

    componentDidMount() {

        this.disableDataDiNascitaERadioButton()
        this.disablePicker()

        if (!Utils.isEmpty(this.props.segnalazione) && this.props.segnalazione.pazienteId) {
            this.letturaPaziente(this.props.segnalazione.pazienteId)
        } else {
            let pazienteAttuale = this.state.datiPaziente;
            
               
            if (this.props.datiPaziente && (this.props.datiPaziente.nomePaziente || this.props.datiPaziente.cognomePaziente)) {
                pazienteAttuale.nomePaziente = this.props.datiPaziente.nomePaziente;
                pazienteAttuale.cognomePaziente = this.props.datiPaziente.cognomePaziente;
                if (this.props.datiPaziente.dataDiNascita) {
                    pazienteAttuale.dataDiNascita = this.props.datiPaziente.dataDiNascita;
                    let dataCompilazione = new Date(this.props.dataCompilazione);
                    let dataNascita = new Date(Utils.transformDateForBackend(pazienteAttuale.dataDiNascita));

                    if (dataNascita.getTime() > dataCompilazione.getTime()) {
                        pazienteAttuale.eta = 0
                        pazienteAttuale.mesi = 0
                    } else {
                        let dataComp = moment(dataCompilazione);
                        let dataNasc = moment(dataNascita);
                        let anni = dataComp.diff(dataNasc, 'years');
                        let mesi = dataComp.diff(dataNasc, 'months') % 12;

                        pazienteAttuale.eta = anni
                        pazienteAttuale.mesi = mesi
                    }
                }
                 if (this.props.datiPaziente.sesso){
                    pazienteAttuale.sesso=  this.props.datiPaziente.sesso
                 }
                 
                 if(this.props.datiPaziente.comuneResidenza){
                    let comune=this.state.comuniAulssPerCodice[this.props.datiPaziente.comuneResidenza];
                    if(comune){
                        pazienteAttuale.comuneResidenza=comune;
                    
                        pazienteAttuale.aslAppartenenza = comune.codiceAulss;
                        let provincia=this.state.provincePerCodice[comune.codiceProvincia];
                        pazienteAttuale.provinciaResidenza=provincia;
                        let regione=this.state.regioni[provincia.codiceRegione+'0'];
                        pazienteAttuale.regioneResidenza=regione;
                    }else  {
                        let codice='Z'+this.props.datiPaziente.comuneResidenza;
                        let naz=this.state.nazioniPerCodice[codice];
                        pazienteAttuale.comuneResidenza=naz;
                        pazienteAttuale.aslAppartenenza =this.props.ulssSegnalazione
                    }


                 }
                 if(this.props.datiPaziente.indirizzoResidenza){
                    pazienteAttuale.indirizzoResidenza=this.props.datiPaziente.indirizzoResidenza;
                    
                 }

                 if(this.props.datiPaziente.comuneDomicilio){
                    let comune=this.state.comuniAulssPerCodice[this.props.datiPaziente.comuneDomicilio];
                    if(comune){
                        pazienteAttuale.comuneDomicilio=comune;
                        pazienteAttuale.aslDomicilio = comune.codiceAulss;
                    }else{
                         let codice='Z'+this.props.datiPaziente.comuneDomicilio;
                        let naz=this.state.nazioniPerCodice[codice];
                        pazienteAttuale.comuneDomicilio=naz;
                    }
                 }
                 if(this.props.datiPaziente.indirizzoDomicilio){
                    pazienteAttuale.indirizzoDomicilio=this.props.datiPaziente.indirizzoDomicilio;
                    
                 }
                 
            } 
            if(this.props.comuneNascita){
                let comune=this.state.comuniAulssPerCodice[this.props.comuneNascita];
                if(comune)
                    pazienteAttuale.comuneNascita=comune;
                else{
                    let codice='Z'+this.props.comuneNascita;
                    let naz=this.state.nazioniPerCodice[codice];
                    pazienteAttuale.comuneNascita=naz;
                }
            }
            if (this.props.codiceFiscale) {

                pazienteAttuale.codiceFiscale = this.props.codiceFiscale;
            } else if (this.props.stp) {
                pazienteAttuale.stp = this.props.stp;
            }
            this.setState({datiPaziente: pazienteAttuale, disabledCercaPaziente: this.disabilitaCercaPaziente()})

        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.segnalazione !== this.props.segnalazione) {
            if (!Utils.isEmpty(this.props.segnalazione) && this.props.segnalazione.pazienteId) {
                this.letturaPaziente(this.props.segnalazione.pazienteId)
            }
        }
        if (prevProps.propsPerDatiPaziente !== this.props.propsPerDatiPaziente && !Utils.isEmpty(this.props.propsPerDatiPaziente)) {
            let datiPaziente = {
                nomePaziente: "",
                cognomePaziente: "",
                dataDiNascita: "",
                codiceFiscale: "",
                stp: "",
                sesso: "",
                eta: "",
                mesi: "",
                comuneNascita: "",
                cfNonNoto: "",
                nonInRegola: "",
                senzaFissaDimora: "",
                regioneResidenza: "",
                provinciaResidenza: "",
                comuneResidenza: "",
                indirizzoResidenza: "",
                aslAppartenenza: "",
                comuneDomicilio: "",
                indirizzoDomicilio: "",
                aslDomicilio: "",
                cittadinanza: "",
                recapitoTelefonicoPaziente: "",
                ssn: "",
                professione: "",
                soggettoAnonimizzato: ""
            }
            let disableSoggetto = Utils.controlloModificaCampi(this.props.segnalazione);

            let state = {
                rowsTabPaziente: this.props.propsPerDatiPaziente.rowsTabPaziente,
                showTablePaziente: this.props.propsPerDatiPaziente.showTablePaziente,
                totalElementsTabPaziente: this.props.propsPerDatiPaziente.totalElementsTabPaziente,
                disabled: this.props.propsPerDatiPaziente.disabled,
                disableSoggetto: disableSoggetto,
                // formPazienteSpecifico:true,
                datiPaziente: datiPaziente,
                disabledPulisciCampi: this.props.propsPerDatiPaziente.disabled
            }
            this.setState(state)
        }
        this.disableDataDiNascitaERadioButton()
        this.disablePicker()

    }

    // colonne tabella paziente
    colsTabPaziente = [
        {key: "checked", name: "", tipo: "checkbox", isRadio: true},
        {key: "cognomeNome", name: "Cognome e Nome", sortDirection: "none"},
        {key: "codiceFiscale", name: "Codice Fiscale", sortDirection: "none"},
        {key: "dataNascita", name: "Data di Nascita", sortDirection: "none"},

    ]

    disablePicker() {
        if (this.state.disabled) {
            $(document).ready(function () {
                $("#idAslAppartenenza").selectpicker('disabled')
                $('.selectpicker').selectpicker('refresh')
            });
        } else {
            $(document).ready(function () {
                $("#idAslAppartenenza").selectpicker('disabled', false)
                $('.selectpicker').selectpicker('refresh')
            });
        }

        if (this.props.segnalazioneModifica && (this.props.segnalazione && this.props.segnalazione.migrazione) || (this.props.segnalazioneModifica.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneModifica.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) {
            $(document).ready(function () {
                $("#professione").selectpicker('disabled')
                $('.selectpicker').selectpicker('refresh')
            });
        } else {
            $(document).ready(function () {
                $("#professione").selectpicker('disabled', false)
                $('.selectpicker').selectpicker('refresh')
            });
        }

    }

    disableDataDiNascitaERadioButton(state, callback) {

        if (this.state.disabled) {
            document.getElementById("sessoF").disabled = true
            document.getElementById("sessoM").disabled = true
        } else {
            document.getElementById("sessoF").disabled = false
            document.getElementById("sessoM").disabled = false
        }
    }

    aggiungiToaster(text, tipo, textList, title) {
        ToasterSingleton.instance().aggiuntaToaster({
            type: tipo ?? toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now(),
            textList: textList ?? false,
            title: title ?? null
        })
    }

    pulisciCampiPaziente() {

        let datiPaziente = {
            nomePaziente: "",
            cognomePaziente: "",
            dataDiNascita: "",
            codiceFiscale: "",
            stp: "",
            sesso: "",
            eta: "",
            mesi: "",
            comuneNascita: "",
            cfNonNoto: "",
            nonInRegola: "",
            senzaFissaDimora: "",
            regioneResidenza: "",
            provinciaResidenza: "",
            comuneResidenza: "",
            indirizzoResidenza: "",
            aslAppartenenza: "",
            comuneDomicilio: "",
            indirizzoDomicilio: "",
            aslDomicilio: "",
            cittadinanza: "",
            recapitoTelefonicoPaziente: "",
            ssn: "",
            professione: "",
            soggettoAnonimizzato: ""
        }
        this.props.setTipoCompilazioneDatiPaziente(false)
        this.setState({
            disabled: false,
            formPazienteSpecifico: true,
            disabledDataNascitaRicerca: true,
            datiPaziente: datiPaziente,
            disableSoggetto: false,
            disabledCercaPaziente: true,
            disabledPulisciCampi: false,
            updateCalendar: true
        }, () => {
            this.props.setDatiPaziente(this.state.datiPaziente)
            this.props.isModificaAnagrafe(false)
            this.disableDataDiNascitaERadioButton()
        })
    }

    riceviValore(field, event) {
        let datiPaziente = this.state.datiPaziente
        let state = this.state
        datiPaziente[field] = event.target.value
        if (datiPaziente[field] === "false") {
            datiPaziente[field] = ""
        } else if (datiPaziente[field] === "true") {
            datiPaziente[field] = true
        }
        if (!datiPaziente.regioneResidenza.codice) {
            datiPaziente.provinciaResidenza = ""
        }
        if (!datiPaziente.provinciaResidenza.codice && datiPaziente.comuneResidenza.codiceProvincia) {
            datiPaziente.comuneResidenza = ""
        }
        if (datiPaziente.regioneResidenza.codice && !datiPaziente.comuneResidenza.codiceProvincia) {
            //caso in cui regione valorizzata , ma comune è uno stato estero
            datiPaziente.comuneResidenza = ""
        }


        if (field === "soggettoAnonimizzato") {
            datiPaziente.nomePaziente = "ANONIMO"
            datiPaziente.cognomePaziente = "ANONIMO"
            datiPaziente.dataDiNascita = ""
            datiPaziente.codiceFiscale = ""
            datiPaziente.stp = ""
            datiPaziente.sesso = ""
            datiPaziente.eta = ""
            datiPaziente.mesi = ""
            datiPaziente.comuneNascita = ""
            datiPaziente.nonInRegola = ""
            datiPaziente.senzaFissaDimora = ""
            datiPaziente.regioneResidenza = ""
            datiPaziente.provinciaResidenza = ""
            datiPaziente.comuneResidenza = ""
            datiPaziente.indirizzoResidenza = ""
            datiPaziente.aslAppartenenza = ""
            datiPaziente.comuneDomicilio = ""
            datiPaziente.indirizzoDomicilio = ""
            datiPaziente.aslDomicilio = ""
            datiPaziente.cittadinanza = ""
            datiPaziente.recapitoTelefonicoPaziente = ""
            datiPaziente.ssn = ""
            datiPaziente.professione = ""
            state["formPazienteSpecifico"] = false;
            state["disabled"] = false;
            state["disabledPulisciCampi"] = false;
            state["disableSoggetto"] = Utils.controlloModificaCampi(this.props.segnalazione);
            datiPaziente["cfNonNoto"] = true;
            this.props.isModificaAnagrafe(false)
        }
        if (field === "dataDiNascita" && Utils.isDateValid(Utils.transformDateForBackend(datiPaziente.dataDiNascita), "-")) {
            let dataCompilazione = new Date(this.props.dataCompilazione);
            let dataNascita = new Date(Utils.transformDateForBackend(datiPaziente.dataDiNascita));

            if (dataNascita.getTime() > dataCompilazione.getTime()) {
                datiPaziente.eta = 0
                datiPaziente.mesi = 0
            } else {
                let dataComp = moment(dataCompilazione);
                let dataNasc = moment(dataNascita);
                let anni = dataComp.diff(dataNasc, 'years');
                let mesi = dataComp.diff(dataNasc, 'months') % 12;

                datiPaziente.eta = anni
                datiPaziente.mesi = mesi
            }
        }
        if (this.state.formPazienteSpecifico && (this.state.datiPaziente.codiceFiscale || this.state.datiPaziente.cognomePaziente || this.state.datiPaziente.nomePaziente || this.state.datiPaziente.dataDiNascita)) {
            datiPaziente.stp = ""
        } else if (this.state.formPazienteSpecifico && (this.state.datiPaziente.stp || this.state.datiPaziente.cognomePaziente || this.state.datiPaziente.nomePaziente || this.state.datiPaziente.dataDiNascita)) {
            datiPaziente.codiceFiscale = ""
        } else if (this.state.formPazienteSpecifico && (this.state.datiPaziente.stp || this.state.datiPaziente.codiceFiscale)) {
            datiPaziente.cognomePaziente = ""
            datiPaziente.nomePaziente = ""
            datiPaziente.dataDiNascita = ""
        }
        if (field === "senzaFissaDimora") {
            datiPaziente.regioneResidenza = ""
            datiPaziente.provinciaResidenza = ""
            datiPaziente.comuneResidenza = ""
            datiPaziente.indirizzoResidenza = ""
            datiPaziente.aslAppartenenza = ""
            datiPaziente.comuneDomicilio = ""
            datiPaziente.indirizzoDomicilio = ""
            datiPaziente.aslDomicilio = ""
        }

        state.datiPaziente = datiPaziente
        state.disabledCercaPaziente = this.disabilitaCercaPaziente()
        if (datiPaziente.comuneResidenza && datiPaziente.comuneResidenza.codice) {
            state.aulssByCodiceComuneResidenza = this.state.comuniAulssPerCodice[datiPaziente.comuneResidenza.codice] ? this.state.comuniAulssPerCodice[datiPaziente.comuneResidenza.codice].codiceAulss : ""
            state.datiPaziente.aslAppartenenza = state.aulssByCodiceComuneResidenza ? state.aulssByCodiceComuneResidenza : datiPaziente.aslAppartenenza
        } else {
            state.aulssByCodiceComuneResidenza = ""
        }
        if (!datiPaziente.regioneResidenza && !datiPaziente.provinciaResidenza && (datiPaziente.comuneResidenza && datiPaziente.comuneResidenza.codice)){
            state.aulssByCodiceComuneResidenza= this.props.ulssSegnalazione.codice
            state.datiPaziente.aslAppartenenza = state.aulssByCodiceComuneResidenza ? state.aulssByCodiceComuneResidenza : datiPaziente.aslAppartenenza
        }
        if (datiPaziente.comuneDomicilio && datiPaziente.comuneDomicilio.codice) {
            state.aulssByCodiceComuneDomicilio = this.state.comuniAulssPerCodice[datiPaziente.comuneDomicilio.codice] ? this.state.comuniAulssPerCodice[datiPaziente.comuneDomicilio.codice].codiceAulss : ""
            state.datiPaziente.aslDomicilio = state.aulssByCodiceComuneDomicilio ? state.aulssByCodiceComuneDomicilio : datiPaziente.aslDomicilio
        } else {
            state.aulssByCodiceComuneDomicilio = ""
        }
        this.setState(state)
        this.props.setDatiPaziente(datiPaziente)
    }


    disabilitaCercaPaziente() {

        let disabled = true;

        if (this.state.datiPaziente.stp && !this.state.datiPaziente.codiceFiscale && (!this.state.datiPaziente.nomePaziente && !this.state.datiPaziente.cognomePaziente && !this.state.datiPaziente.dataDiNascita))
            disabled = false;
        else if (!this.state.datiPaziente.stp && (this.state.datiPaziente.codiceFiscale && Utils.isCFValid(this.state.datiPaziente.codiceFiscale)) && (!this.state.datiPaziente.nomePaziente && !this.state.datiPaziente.cognomePaziente && !this.state.datiPaziente.dataDiNascita))
            disabled = false;
        else if (!this.state.datiPaziente.stp && !this.state.datiPaziente.codiceFiscale &&
            (this.state.datiPaziente.nomePaziente && this.state.datiPaziente.cognomePaziente && this.state.datiPaziente.dataDiNascita &&
                !Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiPaziente.dataDiNascita), "-")))
            disabled = false;
        return disabled
    }

    selezionaPaziente(row, isChecked) {
        this.props.setTipoCompilazioneDatiPaziente(true)
        this.props.setDatiPaziente(Utils.mapGetPazientePerForm(row))
        this.setState({
                formPazienteSpecifico: !isChecked, datiPaziente: Utils.mapGetPazientePerForm(row),
                disabledPulisciCampi: false,
                disabled: true, showTablePaziente: false
            }, () => this.props.isModificaAnagrafe(true)
        )
    }


    sendRequestPaziente() {

        if (this.state.datiPaziente.dataDiNascita) {
            let validateDataNascita = Utils.checkDateInterval(this.state.datiPaziente.dataDiNascita, "31/12/1899");

            if (validateDataNascita) {
                return (this.aggiungiToaster(["Messages.ERR_01_01_0B_0G"]))
            }
            if (
                (this.state.datiPaziente.cognomePaziente && this.state.datiPaziente.cognomePaziente.length < 2) ||
                (this.state.datiPaziente.nomePaziente && this.state.datiPaziente.nomePaziente.length < 2)) {
                return (this.aggiungiToaster(["Messages.ERR_01_01_0B_0T"]))
            }

        }

        let params = {
            ulss: SessioneUtente.getInstance().ulss
        }

        if (this.state.datiPaziente.nomePaziente) {
            if (this.state.datiPaziente.nomePaziente.startsWith(" ") || this.state.datiPaziente.nomePaziente.endsWith(" ")) {
                params["nome"] = this.state.datiPaziente.nomePaziente.trim()
            } else {
                params["nome"] = this.state.datiPaziente.nomePaziente
            }
        }

        if (this.state.datiPaziente.cognomePaziente) {
            if (this.state.datiPaziente.cognomePaziente.startsWith(" ") || this.state.datiPaziente.cognomePaziente.endsWith(" ")) {
                params["cognome"] = this.state.datiPaziente.cognomePaziente.trim()
            } else {
                params["cognome"] = this.state.datiPaziente.cognomePaziente
            }
        }

        if (this.state.datiPaziente.codiceFiscale) {
            params["codiceFiscale"] = this.state.datiPaziente.codiceFiscale
        }

        if (this.state.datiPaziente.dataDiNascita) {
            params["dataNascita"] = Utils.transformDateForBackend(this.state.datiPaziente.dataDiNascita)
        }

        if (this.state.datiPaziente.stp) {
            params["stp"] = this.state.datiPaziente.stp
        }

        this.props.showSpinner(true);
        PazientiService.getPazienti(params).then((data) => {
            if (data.data.anagraficaRicercaDTOList && data.data.anagraficaRicercaDTOList.length > 0) {
                let res = Utils.mapGetPaziente(data, Utils.transformTimeStampForFrontend(this.props.dataCompilazione));
                this.setState({
                    rowsTabPaziente: res,
                    showTablePaziente: true,
                    totalElementsTabPaziente: res.length,
                    disabled: false,
                    disableSoggetto: true,
                    disabledPulisciCampi: false
                })
            } else {
                let disableSoggetto = Utils.controlloModificaCampi(this.props.segnalazione)
                this.setState({
                    showTablePaziente: true, rowsTabPaziente: [], formPazienteSpecifico: false,
                    disabled: false, disableSoggetto: disableSoggetto, disabledPulisciCampi: false
                })
            }
            this.props.showSpinner(false);
            //toaster
            let issues = data.data.issues ?? null
            if (issues) {
                let textList = []
                issues.forEach(issue => {
                    textList.push(issue.message)

                })
                if (textList.length > 0) return this.aggiungiToaster(textList, toasterConfig.types.confirm, true, "warningAnagrafe")
            }
        }).catch(() => {
            this.setState({showTablePaziente: true, rowsTabPaziente: [], formPazienteSpecifico: false})
            this.props.showSpinner(false);
        });
    }

    letturaPaziente(idPaziente) {
        PazientiService.letturaPaziente(idPaziente).then((data) => {
            let datiPaziente = Utils.mapGetPazientePerModifica(data.data, this.props.dataCompilazione)
            if ((!datiPaziente.nomePaziente && !datiPaziente.cognomePaziente) ||
                (datiPaziente.nomePaziente.toUpperCase() === "ANONIMO" && datiPaziente.cognomePaziente === "ANONIMO")) { //soggetto anonimizzato
                datiPaziente.soggettoAnonimizzato = true;
            }
            let disableSoggetto = Utils.controlloModificaCampi(this.props.segnalazione)
            let ulssByCodiceComuneResidenza = ""
            let ulssByCodiceComuneDomicilio = ""
            if (this.props.segnalazioneModifica && !(this.props.segnalazione.migrazione ||
                this.props.segnalazioneModifica.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                this.props.segnalazioneModifica.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) {
                if (datiPaziente.comuneResidenza && datiPaziente.comuneResidenza.codice) {
                    ulssByCodiceComuneResidenza = this.state.comuniAulssPerCodice[datiPaziente.comuneResidenza.codice] ? this.state.comuniAulssPerCodice[datiPaziente.comuneResidenza.codice].codiceAulss : ""
                    datiPaziente.aslAppartenenza = ulssByCodiceComuneResidenza ? ulssByCodiceComuneResidenza : datiPaziente.aslAppartenenza
                }
                if (datiPaziente.comuneDomicilio && datiPaziente.comuneDomicilio.codice) {
                    ulssByCodiceComuneDomicilio = this.state.comuniAulssPerCodice[datiPaziente.comuneDomicilio.codice] ? this.state.comuniAulssPerCodice[datiPaziente.comuneDomicilio.codice].codiceAulss : ""
                    datiPaziente.aslDomicilio = ulssByCodiceComuneDomicilio ? ulssByCodiceComuneDomicilio : datiPaziente.aslDomicilio
                }
            }
            this.setState({
                datiPaziente: datiPaziente,
                formPazienteSpecifico: false,
                disabled: true,
                disableSoggetto: disableSoggetto,
                disabledPulisciCampi: disableSoggetto,
                aulssByCodiceComuneResidenza: ulssByCodiceComuneResidenza,
                aulssByCodiceComuneDomicilio: ulssByCodiceComuneDomicilio

            })
            this.props.setDatiPaziente(this.state.datiPaziente)
            this.props.isModificaPrevAnagrafe(data.data.isAnagrafe)
            $('.selectpicker').selectpicker("render");
        }).catch((reason) => {
            console.log("[ERROR] get lettura paziente: " + reason)
        });
    }

    render() {
        const {t} = this.props;

        let arrayAulss = []
        if (this.state.aulssByCodiceComuneResidenza) {
            arrayAulss = []
            this.state.aulss.map(oggetto => {
                if (oggetto.codice===this.state.aulssByCodiceComuneResidenza || oggetto.codice===this.state.datiPaziente.aslAppartenenza) {
                    oggetto.codice = oggetto.codiceAziendaEsteso
                    oggetto.descrizione = oggetto.descrizione
                    arrayAulss.push(oggetto)
                }
            })
        } else {
            this.state.aulss.map(oggetto => {
                oggetto.codice = oggetto.codiceAziendaEsteso
                oggetto.descrizione = oggetto.descrizione
                arrayAulss.push(oggetto)
            })
        }

        let arrayAulssDomicilio = []
        if (this.state.aulssByCodiceComuneDomicilio) {
            arrayAulssDomicilio = []
            this.state.aulss.map(oggetto => {
                if (oggetto.codice===this.state.aulssByCodiceComuneDomicilio) {
                    oggetto.codice = oggetto.codiceAziendaEsteso
                    oggetto.descrizione = oggetto.descrizione
                    arrayAulssDomicilio.push(oggetto)
                }
            })
        } else {
            this.state.aulss.map(oggetto => {
                oggetto.codice = oggetto.codiceAziendaEsteso
                oggetto.descrizione = oggetto.descrizione
                arrayAulssDomicilio.push(oggetto)
            })
        }

        let professioniLista = []
        Object.keys(OggettiUtili.Professioni).map((key) => {
            if (key != 0 || key != 99 || key != 88)
                return professioniLista.push(OggettiUtili.Professioni[key]);
        })

        let lista = Utils.sortByKey(professioniLista, "descrizione");
        Utils.arrayMove(lista, Utils.checkObjectInArrayByObjectId(lista, "codice", "99"), 0); // non NOTA
        Utils.arrayMove(lista, Utils.checkObjectInArrayByObjectId(lista, "codice", "0"), 0);  // NON INDICATA
        Utils.arrayMove(lista, Utils.checkObjectInArrayByObjectId(lista, "codice", "88"), lista.length - 1);  // ALTRO

        let comuniNazioni = this.state.comuni.concat(this.state.nazioni)
        let comuniNazioniNascita = this.state.comuniNascita.concat(this.state.nazioni)
        comuniNazioniNascita.splice(comuniNazioniNascita.indexOf("Italia"));

        const datiPaziente = (
            <div>
                <div style={{marginTop: "2rem"}}>
                    <div className={"row"}>
                        <div className="col-lg-9">
                            <h6 style={{marginTop: "1rem"}}>{t("DatiSegnalazioneAnagrafici.Dati_anagrafici_del_Paziente")}</h6>
                        </div>
                        <div className="col-lg-3">
                            <Button id={"idButtonClean"}
                                    text={"Pulisci campi"}
                                    onClick={this.pulisciCampiPaziente}
                                    style={{
                                        display: this.state.formPazienteSpecifico ? "none" : "",
                                        height: "2rem",
                                        marginTop: "1rem",
                                        float: "right",
                                        width: "70%"
                                    }}
                                    className={"btnWhite"}
                                    disabled={this.state.disabled && this.state.disabledPulisciCampi}
                            >
                            </Button>
                        </div>

                    </div>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div>
                    <CheckBox id={"soggettoAnonimizzato"}
                              isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                              checked={this.state.datiPaziente.soggettoAnonimizzato}
                              disabledFlag={this.state.disableSoggetto}
                              text={t("DatiSegnalazioneAnagrafici.Soggetto_Anonimizzato")}
                              onChange={this.riceviValore}
                              fontColor={"#1b7ea9"}
                              fontSize={"16px"}
                              newCheckbox={true}
                    >
                    </CheckBox>
                </div>
                <div className="container">
                    <div className="row">
                        <div className={this.state.formPazienteSpecifico ? "col-lg-4" : "col-lg-3"}>
                            <div className={this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? "livello4" : ""}>
                                <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                    <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                        {t("DatiSegnalazioneAnagrafici.cognome")}
                                        {this.state.formPazienteSpecifico || this.state.datiPaziente.soggettoAnonimizzato ?
                                            <span/> :
                                            <span className={styles.mandatoryColor}>*</span>}</p>
                                    <Input id={"idCognomePaziente"} onChange={this.riceviValore}
                                           field={"cognomePaziente"}
                                           errorMessage={"Cognome non valido"}
                                           value={this.state.datiPaziente.cognomePaziente}
                                           placeholder={t("GestioneSegnalazioni.ricerca.cognome")}
                                           disabled={(this.state.formPazienteSpecifico && (this.state.datiPaziente.codiceFiscale || this.state.datiPaziente.stp)) || this.state.disabled || this.state.datiPaziente.soggettoAnonimizzato}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={
                            this.state.formPazienteSpecifico ? "col-lg-4" : "col-lg-3"}>
                            <div className={this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? "livello3" : ""}>
                                <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                    <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                        {t("DatiSegnalazioneAnagrafici.nome")}
                                        {this.state.formPazienteSpecifico || this.state.datiPaziente.soggettoAnonimizzato ?
                                            <span/> :
                                            <span className={styles.mandatoryColor}>*</span>}</p>
                                    <Input id={"idNomePaziente"} onChange={this.riceviValore}
                                           field={"nomePaziente"}
                                           errorMessage={"Nome non valido"}
                                           value={this.state.datiPaziente.nomePaziente}
                                           placeholder={t("GestioneSegnalazioni.ricerca.nome")}
                                           disabled={(this.state.formPazienteSpecifico && (this.state.datiPaziente.codiceFiscale || this.state.datiPaziente.stp)) || this.state.disabled || this.state.datiPaziente.soggettoAnonimizzato}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-4 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.dataDiNascita")}
                                    {this.state.formPazienteSpecifico ? <span/> :
                                        <span className={styles.mandatoryColor}>*</span>}</p>
                                <div>
                                    <Calendar
                                        id={"dataDiNascita"} value={this.state.datiPaziente.dataDiNascita}
                                        field={"dataDiNascita"}
                                        onChange={this.riceviValore}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_ANNO_NASCITA"), "<nome campo>", t("DatiSegnalazioneAnagrafici.dataDiNascita"))}
                                        error={(this.state.datiPaziente.dataDiNascita === "" || this.state.datiPaziente.dataDiNascita == null) ? false :
                                            (Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiPaziente.dataDiNascita), "-") || Utils.checkDateInterval(this.state.datiPaziente.dataDiNascita, "31/12/1908"))
                                        }
                                        disabled={(this.state.formPazienteSpecifico && (this.state.datiPaziente.codiceFiscale || this.state.datiPaziente.stp)) || this.state.disabled}
                                        newCalendar={true}
                                    >
                                    </Calendar>
                                </div>

                            </div>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`} style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9", paddingLeft: "10px"}}>
                                    {t("DatiSegnalazioneAnagrafici.sesso")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <div className={"row"}>
                                    <RadioButton id={"sessoM"} name={"sesso"} label={"M"}
                                                 onClick={this.riceviValore}
                                                 smallLabel={true} value={"M"}
                                                 disabled={this.state.disabled}
                                                 newRadio={true}
                                                 checked={this.state.datiPaziente.sesso === "M"}/>
                                    <RadioButton id={"sessoF"} name={"sesso"} label={"F"}
                                                 onClick={this.riceviValore} smallLabel={true}
                                                 value={"F"}
                                                 disabled={this.state.disabled}
                                                 newRadio={true}
                                                 checked={this.state.datiPaziente.sesso === "F"}>
                                    </RadioButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                        <div className={"col-lg-2"}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.anni")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <Input id={"idEta"} onChange={this.riceviValore}
                                       type="number"
                                       min="0"
                                       field={"eta"}
                                       value={this.state.datiPaziente.eta}
                                       disabled={true}
                                       placeholder={t("DatiSegnalazioneAnagrafici.anni")}
                                />
                            </div>
                        </div>
                        <div className={"col-lg-2"}>
                            <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                {t("DatiSegnalazioneAnagrafici.mesi")}
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                            <Input id={"idMesi"} onChange={this.riceviValore}
                                   type="number"
                                   min="0"
                                   field={"mesi"}
                                   value={this.state.datiPaziente.mesi}
                                   disabled={true}
                                   placeholder={t("DatiSegnalazioneAnagrafici.mesi")}
                            />
                        </div>
                        <div className="col-lg-4">
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.Comune_di_nascita")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <Autocomplete id={"idComuneNascita"}
                                              value={this.state.datiPaziente.comuneNascita}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"comuneNascita"}
                                              placeholder={t("DatiSegnalazioneAnagrafici.Comune_di_nascita")}
                                              suggestions={comuniNazioniNascita}
                                >
                                </Autocomplete>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className={this.state.formPazienteSpecifico ? "col-lg-12" : "col-lg-3"}>
                            <div>
                                <p className={styles.labelHeader}
                                   style={{
                                       display: this.state.formPazienteSpecifico ? "" : "none",
                                       textAlign: "center",
                                       fontSize: "18px"
                                   }}>
                                    {t("DatiSegnalazioneAnagrafici.Oppure")}
                                </p>
                            </div>
                            <div className={this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? "livello4" : ""}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.cf")}
                                    {this.state.formPazienteSpecifico || this.state.datiPaziente.soggettoAnonimizzato ?
                                        <span/> :
                                        <span className={styles.mandatoryColor}>*</span>}
                                </p>
                                <Input id={"idCodFiscale"} onChange={this.riceviValore} field={"codiceFiscale"}
                                       onValidate={this.state.datiPaziente.codiceFiscale && !Utils.isCFValid(this.state.datiPaziente.codiceFiscale) ? 1 : 2}
                                       errorMessage={"Codice fiscale non valido. Inserire un codice fiscale valido"}
                                       disabled={(this.state.formPazienteSpecifico && (this.state.datiPaziente.cognomePaziente || this.state.datiPaziente.nomePaziente || this.state.datiPaziente.dataDiNascita || this.state.datiPaziente.stp)) || this.state.disabled || this.state.datiPaziente.soggettoAnonimizzato}
                                       value={this.state.datiPaziente.codiceFiscale}
                                       placeholder={t("DatiSegnalazioneAnagrafici.cf")}
                                >
                                </Input>
                            </div>
                        </div>
                        <div className="col-lg-2" style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                            <div className={styles.fieldContainer} style={{paddingTop: "1rem"}}
                            >
                                <CheckBox id={"cfNonNoto"}
                                          checked={this.state.datiPaziente.cfNonNoto}
                                          disabledFlag={!!(this.state.disabled || this.state.datiPaziente.soggettoAnonimizzato)}
                                          text={t("DatiSegnalazioneAnagrafici.cfNonNoto")}
                                          onChange={this.riceviValore}
                                          newCheckbox={true}
                                          fontColor={"#1b7ea9"}
                                          fontSize={"16px"}
                                >
                                </CheckBox>
                            </div>
                        </div>
                        <div className={`col-lg-4 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`} style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                            <div className={styles.fieldContainer}>
                                <p className={styles.labelHeader}
                                   style={{color: "#1b7ea9", fontSize: "13.5px", paddingTop: "7px"}}>
                                    {t("DatiSegnalazioneAnagrafici.stp")}
                                    {this.state.datiPaziente.soggettoAnonimizzato ? <span/> :
                                        <span className={styles.mandatoryColor}>*</span>}
                                    <span style={{marginLeft: "3px", color: "black", fontSize: "8px"}}>
                                        {t("DatiSegnalazioneAnagrafici.cittadini_stranieri")}</span>
                                </p>
                                <Input id={"idStp"} onChange={this.riceviValore} field={"stp"}
                                       value={this.state.datiPaziente.stp}
                                       placeholder={t("DatiSegnalazioneAnagrafici.stp")}
                                       onValidate={(!Utils.isObjectEmpty(this.state.datiPaziente.stp)) ? (this.state.datiPaziente.stp.replace(/ +/g, "").length === 0 || this.state.datiPaziente.stp.startsWith(" ") ? 1 : 2) : 0}
                                       errorMessage={"STP non valido"}
                                       disabled={this.state.disabled || this.state.datiPaziente.soggettoAnonimizzato}
                                />
                            </div>
                        </div>
                        <div className="col-lg-3" style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                            <div className={styles.fieldContainer} style={{marginRight: "10px"}}>
                                <div>
                                    <CheckBox id={"nonInRegola"}
                                              isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                              checked={this.state.datiPaziente.nonInRegola}
                                              disabledFlag={this.state.disabled}
                                              text={t("DatiSegnalazioneAnagrafici.nonInRegola")}
                                              onChange={this.riceviValore}
                                              newCheckbox={true}
                                              fontColor={"#1b7ea9"}
                                              fontSize={"16px"}
                                    >
                                    </CheckBox>
                                    <CheckBox id={"senzaFissaDimora"}
                                              isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                              checked={this.state.datiPaziente.senzaFissaDimora}
                                              disabledFlag={this.state.disabled}
                                              text={t("DatiSegnalazioneAnagrafici.senzaFissaDimora")}
                                              onChange={this.riceviValore}
                                              newCheckbox={true}
                                              fontColor={"#1b7ea9"}
                                              fontSize={"16px"}
                                    >
                                    </CheckBox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.regioneResidenza")}
                                </p>
                                <Autocomplete
                                    id={"idRegioneResidenza"}
                                    onChange={this.riceviValore}
                                    field={"regioneResidenza"}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    value={this.state.datiPaziente.regioneResidenza}
                                    suggestions={this.state.regioni}
                                    placeholder={t("DatiSegnalazioneAnagrafici.regioneResidenza")}
                                    disabled={this.state.datiPaziente.senzaFissaDimora}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.provinciaResidenza")}
                                </p>
                                <Autocomplete id={"idProvinciaResidenza"}
                                              value={this.state.datiPaziente.provinciaResidenza}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"provinciaResidenza"}
                                              placeholder={t("DatiSegnalazioneAnagrafici.provinciaResidenza")}
                                              suggestions={this.state.datiPaziente.regioneResidenza.codice ?
                                                  Utils.filtroProvinceComuni(this.state.datiPaziente.regioneResidenza.codice, this.state.province, "codiceRegione") : ""}
                                              disabled={!this.state.datiPaziente.regioneResidenza.codice || this.state.datiPaziente.senzaFissaDimora}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.comuneResidenza")}
                                    {this.state.datiPaziente.senzaFissaDimora ?
                                        <></> :
                                        <span className={styles.mandatoryColor}>*</span>}
                                </p>
                                <Autocomplete id={"idComuneResidenza"}
                                              value={this.state.datiPaziente.comuneResidenza}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"comuneResidenza"}
                                              placeholder={t("DatiSegnalazioneAnagrafici.comuneResidenza")}
                                              disabled={(this.state.datiPaziente.regioneResidenza.codice && !this.state.datiPaziente.provinciaResidenza.codice) || this.state.datiPaziente.senzaFissaDimora}
                                              suggestions={this.state.datiPaziente.regioneResidenza.codice ? (this.state.datiPaziente.provinciaResidenza.codice ?
                                                  Utils.filtroProvinceComuni(this.state.datiPaziente.provinciaResidenza.codice, this.state.comuni, "codiceProvincia") : this.state.comuni) : this.state.nazioni}

                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.indirizzoResidenza")}
                                    {this.state.datiPaziente.comuneResidenza ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}

                                </p>
                                <Input id={"idIndirizzoResidenza"} onChange={this.riceviValore}
                                       field={"indirizzoResidenza"}
                                       errorMessage={"Indirizzo non valido"}
                                       value={this.state.datiPaziente.indirizzoResidenza}
                                       placeholder={t("DatiSegnalazioneAnagrafici.indirizzoResidenza")}
                                       disabled={this.state.datiPaziente.senzaFissaDimora}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                        <div className="col-lg-3">
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.aslAppartenenza")}
                                    {!this.state.datiPaziente.senzaFissaDimora && this.state.datiPaziente.comuneResidenza ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}
                                </p>
                                <fieldset>
                                    <SelectAutocomplete
                                        validata={this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice}
                                        id={"idAslAppartenenza"}
                                        field={"aslAppartenenza"}
                                        value={this.state.datiPaziente.aslAppartenenza}
                                        newSelect={true}
                                        onChange={this.riceviValore}
                                        disabled={this.state.datiPaziente.senzaFissaDimora}
                                        functionMap={arrayAulss.map((oggetto) => {
                                            return (
                                                <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        })}
                                    >
                                    </SelectAutocomplete></fieldset>
                            </div>
                        </div>
                        <div
                             className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}
                        >
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.comuneDomicilio")}
                                </p>
                                <Autocomplete id={"idComuneDomicilio"}
                                              value={this.state.datiPaziente.comuneDomicilio}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"comuneDomicilio"}
                                              placeholder={t("DatiSegnalazioneAnagrafici.comuneDomicilio")}
                                              suggestions={comuniNazioni}
                                              disabled={this.state.datiPaziente.senzaFissaDimora}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.indirizzoDomicilio")}
                                </p>
                                <Input id={"idIndirizzoDomicilio"} onChange={this.riceviValore}
                                       field={"indirizzoDomicilio"}
                                       errorMessage={"Indirizzo non valido"}
                                       value={this.state.datiPaziente.indirizzoDomicilio}
                                       placeholder={t("DatiSegnalazioneAnagrafici.indirizzoDomicilio")}
                                       disabled={this.state.datiPaziente.senzaFissaDimora}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.aslDomicilio")}</p>
                                <fieldset>
                                    <SelectAutocomplete
                                        id={"idAslDomicilio"}
                                        field={"aslDomicilio"}
                                        value={this.state.datiPaziente.aslDomicilio}
                                        newSelect={true}
                                        onChange={this.riceviValore}
                                        disabled={this.state.datiPaziente.senzaFissaDimora}
                                        functionMap={arrayAulssDomicilio.map((oggetto) => {
                                            return (
                                                <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        })}
                                    >
                                    </SelectAutocomplete></fieldset>
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{display: this.state.formPazienteSpecifico ? "none" : ""}}>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.cittadinanza")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <Autocomplete
                                    id={"idCittadinanza"}
                                    value={this.state.datiPaziente.cittadinanza}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"cittadinanza"}
                                    placeholder={t("DatiSegnalazioneAnagrafici.cittadinanza")}
                                    suggestions={this.state.nazioni}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.recapitoTelefonicoPaziente")}
                                </p>
                                <Input id={"idRecapitoTelefonicoPaziente"} onChange={this.riceviValore}
                                       field={"recapitoTelefonicoPaziente"}
                                       errorMessage={"Recapito telefonico non valido"}
                                       value={this.state.datiPaziente.recapitoTelefonicoPaziente}
                                       disabled={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneModifica && (this.props.segnalazioneModifica.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                           this.props.segnalazioneModifica.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))}
                                       placeholder={t("DatiSegnalazioneAnagrafici.recapitoTelefonicoPaziente")}/>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.ssn")}
                                </p>
                                <Input id={"idSsn"} onChange={this.riceviValore} field={"ssn"}
                                       errorMessage={"SSN non valido"}
                                       value={this.state.datiPaziente.ssn}
                                       disabled={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneModifica && (this.props.segnalazioneModifica.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                           this.props.segnalazioneModifica.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))}
                                       placeholder={t("DatiSegnalazioneAnagrafici.ssn")}/>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazione.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div className={styles.fieldContainer} style={{marginRight: "20px"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.professione")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <SelectAutocomplete
                                    id={"professione"}
                                    onChange={this.riceviValore}
                                    disabled={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneModifica && (this.props.segnalazioneModifica.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneModifica.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))}
                                    field={"professione"}
                                    value={this.state.datiPaziente.professione}
                                    functionMap={lista.map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}
                                    newSelect={true}
                                >
                                </SelectAutocomplete>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-12" style={{display: this.state.formPazienteSpecifico ? "" : "none"}}>
                            <div>
                                <p className={styles.labelHeader} style={{textAlign: "center", fontSize: "18px"}}>
                                    {t("DatiSegnalazioneAnagrafici.Oppure")}
                                </p>
                            </div>
                            <div style={{display: this.state.formPazienteSpecifico ? "" : "none"}}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9"}}>
                                    {t("DatiSegnalazioneAnagrafici.stp")}
                                    <span className={"fontSize12"} style={{marginLeft: "3px", color: "black"}}>
                                        {t("DatiSegnalazioneAnagrafici.cittadini_stranieri")}
                                    </span>
                                </p>
                                <Input id={"idStp"} onChange={this.riceviValore} field={"stp"}
                                       value={this.state.datiPaziente.stp}
                                       placeholder={t("DatiSegnalazioneAnagrafici.stp")}
                                       onValidate={(!Utils.isObjectEmpty(this.state.datiPaziente.stp)) ? (this.state.datiPaziente.stp.replace(/ +/g, "").length === 0 || this.state.datiPaziente.stp.startsWith(" ") ? 1 : 2) : 0}
                                       errorMessage={"STP non valido"}
                                       disabled={(this.state.formPazienteSpecifico && (this.state.datiPaziente.codiceFiscale || this.state.datiPaziente.cognomePaziente || this.state.datiPaziente.nomePaziente || this.state.datiPaziente.dataDiNascita)) || !this.state.formPazienteSpecifico}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 text-center"
                             style={{display: this.state.formPazienteSpecifico ? "" : "none"}}>
                            <Button text="Cerca Paziente" disabled={this.state.disabledCercaPaziente}
                                    className={"btnWhite col-lg-2 "} style={{height: "2rem", marginTop: "1rem"}}
                                    onClick={this.sendRequestPaziente}>
                                {t("Buttons.cercaPaziente")}</Button>
                        </div>
                    </div>
                </div>
            </div>
        );

        const tablePaziente = (
            <div className="container mt-3">

                <div className={styles.contenitoreTabella} style={{marginTop: "2px"}}>
                    <Table cols={this.colsTabPaziente} rows={this.state.rowsTabPaziente}
                           title={t("DatiSegnalazioneAnagrafici.listaPaziente")}
                           empty={this.state.rowsTabPaziente && this.state.rowsTabPaziente.length === 0}
                           emptyMsg="Non ci sono pazienti associati a queste credenziali"
                           lengthEditable={false}
                           onSelectCheckbox={this.selezionaPaziente}
                           totalElements={this.state.totalElementsTabPaziente}
                    />
                </div>
            </div>
        );

        return (
            <div>
                {datiPaziente}
                <div>
                    {this.state.showTablePaziente ?
                        <div>{tablePaziente}</div> :
                        <div/>}
                </div>
            </div>
        );


    }

}

export default withTranslation('common')(DatiAnagraficiPaziente)
